import React from 'react';

import cls from './List.module.scss';

export const List = () => (
    <div className={'content'}>
        <div className={cls.page}>
            <h2>Перечень 3-их лиц, которым мы можем передать ваши персональные данные</h2>

            <ul>
                <li>ООО «АРСфин» (ИНН 7722445717)</li>
                <li>ООО «Неотех» (ИНН 9703076320)</li>
                <li>ООО «Метрикс» ( ИНН 9726080796)</li>
                <li>ООО «Банки.ру Искусственный интеллект» (ИНН 7708656561)</li>
                <li>ООО «Нэопэй» (ИНН 9710086922)</li>
                <li>ООО «Кредит.Клаб» (ИНН 6678105594)</li>
                <li>ПАО «МТС-Банк» (ИНН 7702045051)</li>
                <li>ПАО «БАНК УРАЛСИБ» (ИНН 0274062111)</li>
                <li>АО Банк Синара (ИНН 6608003052)</li>
                <li>АО «Почта Банк» (ИНН 3232005484)</li>
                <li>ООО «ЕФИН» (ИНН 9715308819)</li>
                <li>АО КБ «Пойдём!» (ИНН 5401122100)</li>
                <li>АО «Россельхозбанк» (ИНН 7725114488)</li>
                <li>ПАО Банк ЗЕНИТ (ИНН 7729405872)</li>
                <li>ПАО «Совкомбанк» (ИНН 4401116480)</li>
                <li>«ООО «СРАВНИ. РУ» (ИНН 7710718303)</li>
                <li>АО «Кредит Европа Банк» (ИНН 7705148464)</li>
                <li>ООО «ФИНФОРТ-АГЕНТСКИЕ СЕТИ» (ИНН 3019011668)</li>
                <li>Банк ВТБ (ПАО) (ИНН 7702070139)</li>
                <li>КБ «ЛОКО-Банк» (АО) (ИНН 7750003943)</li>

                <li>ИП Винская Ирина Сергеевна (ИНН 502916763858)</li>

                <li>ООО УК «Альфа-Капитал» (ИНН 7728142469)</li>

                <li>ООО «ЭфТиЭс» (ИНН 9707022044)</li>

                <li>АО «ААА Управление Капиталом» (ИНН 7722515837)</li>

                <li>ООО «СиТиЭс» (ИНН 9724148897)</li>

                <li>АО «Тбанк» (ИНН 7710140679)</li>
                <li>ПАО АКБ «МЕТАЛЛИНВЕСТБАНК» (ИНН 7709138570)</li>
                <li>ПАО КБ «УБРиР» (ИНН 6608008004)</li>
                <li>ПАО Московская Биржа (ИНН 7702077840)</li>
                <li>«АТБ» (АО) (ИНН 2801023444) ПАО</li>
                <li>«Промсвязьбанк» (ИНН 7744000912)</li>
                <li>АО «АЛЬФА-БАНК» (ИНН 7728168971)</li>
                <li>«Газпромбанк» (АО) (ИНН 7744001497)</li>
                <li>ООО «Информационное Агентство «Банки.Ру» (ИНН 7723527345)</li>
                <li>АО «НПФ «Социум» (ИНН 7714324003)</li>
                <li>ООО «Медиа Групп» (ИНН 9725086918)</li>

                <li>ПАО «Банк „Санкт-Петербург“»</li>
                <li>АО «Банк Русский Стандарт»</li>
                <li>ПАО «БАНК УРАЛСИБ»</li>
                <li>КБ «Ренессанс Кредит»</li>
                <li>АО «АТБ»</li>
                <li>ПАО Банк «ЗЕНИТ»</li>
                <li>АО КБ «Пойдём!»</li>
                <li>ПАО КБ «УБРиР»</li>
                <li>АО «Банк Русский Стандарт»</li>
                <li>АО «Банк Синара»</li>
                <li>АО «ЮниКредит Банк»</li>
                <li>ПАО «Норвик Банк»</li>

            </ul>
            <p>и иные партнеры, участвующие в достижении цели согласия.</p>
        </div>
    </div>
)